import { useMemo, useState, useTransition } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AllPolicySection from "../../components/AllPolicySection/AllPolicySection";
import { TAB_CONFIG } from "../../utils/allPolicyConstants";

const AllPolicy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const viewMode = location.pathname.includes("all-travelers") ? "travellers" : "trips";

  const roles = useSelector((state) => state.auth?.role || []);
  const allowedTabs = useMemo(
    () => TAB_CONFIG.filter((tab) => !tab.roles || tab.roles.some((role) => roles.includes(role))),
    [roles]
  );

  const [tabValue, setTabValue] = useState("1");
  const [isPending, startTransition] = useTransition();

  const handleTabChange = (newValue) => {
    startTransition(() => setTabValue(newValue));
  };

  const handleViewChange = (value) => {
    navigate(value === "travellers" ? "/issuance/all-travelers" : "/issuance/all-policy");
  };

  return (
    <AllPolicySection
      viewMode={viewMode}
      onViewChange={handleViewChange}
      showStats
      showNav
      allowedTabs={allowedTabs}
      tabValue={tabValue}
      onTabChange={handleTabChange}
      isPending={isPending}
    />
  );
};

export default AllPolicy;
